import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";

export default function Configurations(props) {
  const { application, state, setState } = props;

  const [template, settemplate] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templateview/${application}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => settemplate(resp))
      .catch((error) => {
        console.error(error);
      });
  }, [application]);

  const [instancetype, setInstancetype] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [newstate, setNewstate] = React.useState({});

  const [temporary, settemporary] = React.useState([]);
  const [temporarycount, settemporarycount] = React.useState([]);

  const handleChange = (e, key) => {
    const { id, value } = e.target;

    if (key === "condition") {
      if (newstate[id] && newstate[id] === "yes") {
        setNewstate((prevState) => ({
          ...prevState,
          [id]: "no",
        }));
        setState((prevState) => ({
          ...prevState,
          [id]: "no",
        }));
      } else {
        setNewstate((prevState) => ({
          ...prevState,
          [id]: "yes",
        }));
        setState((prevState) => ({
          ...prevState,
          [id]: "yes",
        }));
      }
    } else {
      setNewstate((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      setState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const renderFields = (template) => {
    return template.map((field) => {
      let { key, title, type, name, description } = field;
      switch (type) {
        case "text":
          return (
            <React.Fragment>
              {key === "storage" ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>
                    {title}
                    <small style={{ paddingLeft: "10px" }}>required</small>
                    <small style={{ color: "red" }}>*</small>
                  </InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        case "select":
          return (
            <React.Fragment>
              {key === "type" ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>
                    {title}
                    <small style={{ paddingLeft: "10px" }}>required</small>
                    <small style={{ color: "red" }}>*</small>
                  </InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : key === "option" ? (
                <Grid item xs={3} key={name}>
                  {" "}
                  <InputLabel>
                    {title}
                    <small style={{ paddingLeft: "10px" }}>required</small>
                    <small style={{ color: "red" }}>*</small>
                  </InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {field.options.map((val) => {
                      // console.log(val);
                      return (
                        <React.Fragment>
                          <option value={val}>{val}</option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        case "option":
          return (
            <React.Fragment>
              {key === "condition" ? (
                <Grid item xs={3} key={name}>
                  <Typography variant="h6">{title}</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={name}
                        onChange={(event) => handleChange(event, key)}
                        color="primary"
                      />
                    }
                    label={<Typography variant="h6"></Typography>}
                  />
                </Grid>
              ) : key === "type" &&
                newstate[field.dependsOn] === field.ostype ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : key === "storage" &&
                newstate[field.dependsOn] === field.ostype ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        case "condition":
          return (
            <React.Fragment>
              {key === "storage" && newstate[field.dependsOn] === "yes" ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>
                    {title}
                    <small style={{ paddingLeft: "10px" }}>required</small>
                    <small style={{ color: "red" }}>*</small>
                  </InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : key === "type" && newstate[field.dependsOn] === "yes" ? (
                <Grid item xs={3} key={name}>
                  <InputLabel>
                    {title}
                    <small style={{ paddingLeft: "10px" }}>required</small>
                    <small style={{ color: "red" }}>*</small>
                  </InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        default:
          return (
            <div key={name}>
              <span className="red-text">
                {name} {type}
              </span>
            </div>
          );
      }
    });
  };

  return <React.Fragment>{renderFields(template)}</React.Fragment>;
}
